import type { IState } from 'shared/store';

export const selectIsEtazhiBlackFridayEnabled = (state: IState) => {
  return !!state.rs.etazhiBlackFridayEnabled;
};
